import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const TermsModal = ({ show, handleClose, handleAccept }) => {
  const { t, i18n } = useTranslation();
  const isArabic = (i18n.language || '').startsWith('ar');
  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('Terms and Conditions')}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        {/* The real terms live in /terms-and-conditions.html so the app, the
            App Store listing and this form all show the same text. */}
        <iframe
          title={t('Terms and Conditions')}
          src={`/terms-and-conditions.html?embed=1${isArabic ? '&lang=ar' : ''}`}
          style={{ display: 'block', width: '100%', height: '60vh', border: 0 }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t('Decline')}
        </Button>
        <Button
          onClick={handleAccept}
          className="px-4 py-2 accept-terms-btn"
          style={{
            borderRadius: "4px",
            fontWeight: "600",
            backgroundColor: "#FFC107",
            borderColor: "#FFC107",
            color: "#212529",
          }}
        >
          {t('I Accept')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsModal;
